import { AMSModules } from "../utils/constants";
import { initialFilterState as applicantsFilterState } from "../pages/Applicants/index";
import { initialFilterState as employeesFilterState } from "../pages/Employees/index";
import { initialFilterState as coursesFilterState } from "../pages/Training/Courses/index";
import { initialFilterState as participantsFilterState } from "../pages/Training/Participants/index";
import { initialFilterState as certificationsFilterState } from "../pages/Training/Certifications/index";
import { initialFilterState as summaryFilterState } from "../pages/Training/Summary/index";

const initialState = {
    applicants: applicantsFilterState,
    employees: employeesFilterState,
    courses: coursesFilterState,
    participants: participantsFilterState,
    certifications: certificationsFilterState,
    summary: summaryFilterState,
};

export default function FiltersInfoReducer(state = initialState, action) {
  switch (action.type) {
    case AMSModules.Applicants:
      return { ...state, applicants: action.payload };

    case AMSModules.Employees:
      return { ...state, employees: action.payload };

    case AMSModules.Courses:
      return { ...state, courses: action.payload };

    case AMSModules.Participants:
      return { ...state, participants: action.payload };

    case AMSModules.Certifications:
      return { ...state, certifications: action.payload };

    case AMSModules.Summary:
      return { ...state, summary: action.payload };
    
    case AMSModules.LogOut:
      return initialState;

    default:
      return state;
  }
}